import ReactPaginate from "react-paginate";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

interface PaginateProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  loading: boolean; // Add loading prop
  displayTotalRecords?: boolean;
  title?:string;
  marginTop?:string;
  /** "yellow" uses the dark #332B00 page numbers from the MNO list redesign. */
  variant?: "default" | "yellow";
}

export default function Paginate({ totalPages, currentPage, onPageChange, loading, displayTotalRecords, title, marginTop, variant = "default" }: PaginateProps) {
  const listState = useSelector((state: RootState) => state.list);
  const { recordCount } = listState;
  return (
    <div className={`flex flex-wrap items-center justify-center z-9 cursor-default relative mt-${marginTop} gap-y-2`}>
      <div className="flex items-center rounded-lg p-1 cursor-default w-full justify-center" data-testid="paginator">
        <ReactPaginate
          previousLabel={
            <div
              className={`rounded-lg w-[28px] h-[28px] sm:w-[36px] sm:h-[36px] flex justify-center prev bg-transparent ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              <img
                loading="lazy"
                decoding="async"
                src={`/images/${currentPage === 1 || loading ? "page-light-right" : "page-dark-right"}.svg`}
                alt="Previous"
                data-testid="previous"
                className={`w-7`}
              />
            </div>
          }
          nextLabel={
            <div
              className={`rounded-lg w-[28px] h-[28px] sm:w-[36px] sm:h-[36px] flex justify-center next bg-transparent ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              <img
                loading="lazy"
                decoding="async"
                src={`/images/${currentPage === totalPages || loading ? "page-light-left" : "page-dark-left"
                  }.svg`}
                alt="Next"
                data-testid="next"
                className={` w-7`}
              />
            </div>
          }
          breakLabel="..."
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          forcePage={currentPage - 1}
          onPageChange={(selected) => !loading && onPageChange(selected.selected + 1)}
          containerClassName={`flex justify-center items-center ${loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          pageClassName={`text-xs sm:text-sm font-normal ${variant === "yellow" ? "text-[#332b00]" : "text-primary_text"} p-1 sm:p-2 min-w-[14px] sm:min-w-[20px] h-5 inline-flex justify-center items-center mx-0.5 sm:mx-1 ${loading ? "pointer-events-none" : ""
            }`}
          activeClassName={`${variant === "yellow" ? "text-[#332b00]!" : "text-p_primary!"} font-bold!`}
          pageLinkClassName="p-1 sm:p-2"
        />
      </div>
      {displayTotalRecords && (
        <p className="w-full text-center sm:w-auto sm:absolute sm:top-1/2 sm:-translate-y-1/2 sm:right-0 text-body2 text-primary_text">
          {`Total Number of ${title} : `}<span className="text-button text-primary_text font-semibold">{recordCount}</span>
        </p>
      )}
    </div>
  );
}
